export function normalizeGitIntegrationBaseUrl(
  value: string | null | undefined,
) {
  if (typeof value !== 'string') {
    return value;
  }

  return value.trim().replace(/\/+$/, '');
}
